import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faXmark, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { useToast } from '../context/ToastContext';

const Toast = () => {
        const { toast } = useToast();

        if (!toast) return null;

        const statusConfig = {
                ok: {
                        icon: faCheck,
                        bgColor: 'bg-green-50',
                        borderColor: 'border-green-200',
                        iconBg: 'bg-green-100',
                        iconColor: 'text-green-600',
                        textColor: 'text-green-800'
                },
                success: {
                        icon: faCheck,
                        bgColor: 'bg-green-50',
                        borderColor: 'border-green-200',
                        iconBg: 'bg-green-100',
                        iconColor: 'text-green-600',
                        textColor: 'text-green-800'
                },
                error: {
                        icon: faXmark,
                        bgColor: 'bg-red-50',
                        borderColor: 'border-red-200',
                        iconBg: 'bg-red-100',
                        iconColor: 'text-red-600',
                        textColor: 'text-red-800'
                },
                warning: {
                        icon: faTriangleExclamation,
                        bgColor: 'bg-yellow-50',
                        borderColor: 'border-yellow-200',
                        iconBg: 'bg-yellow-100',
                        iconColor: 'text-yellow-600',
                        textColor: 'text-yellow-800'
                }
        };

        const config = statusConfig[toast.status] || statusConfig.ok;

        return (
                <div
                        data-testid="toast"
                        data-toast-status={toast.status || 'ok'}
                        className="fixed top-4 left-1/2 transform -translate-x-1/2 z-[10000]"
                        style={{
                                animation: 'fadeInDown 0.3s ease-out'
                        }}
                >
                        <style>
                                {`
					@keyframes fadeInDown {
						from {
							opacity: 0;
							transform: translate(-50%, -20px);
						}
						to {
							opacity: 1;
							transform: translate(-50%, 0);
						}
					}
				`}
                        </style>
                        <div className={`flex items-center gap-3 px-4 py-3 rounded-xl shadow-lg border ${config.bgColor} ${config.borderColor}`}>
                                <div className={`w-8 h-8 rounded-full flex items-center justify-center ${config.iconBg}`}>
                                        <FontAwesomeIcon icon={config.icon} className={`${config.iconColor}`} />
                                </div>
                                <span className={`font-medium ${config.textColor}`}>{toast.message}</span>
                        </div>
                </div>
        );
};

export default Toast;
